
export enum XFlowFrequencyCd {
	DAILY = 'Daily',
	HOURLY = 'Hourly',
	IMMEDIATELY = 'Immediately'}
